import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';


/* Liste des statuts possibles : Créé, affecté, en cours de traitement, clôturé*/
const names = [
    'Ouvert',
    'En cours',
    'Réaffecté',
    'Clôture client',
    'Clôture définitive'
];

class MultipleStatutSelect extends React.Component {


    handleChange = event => {

        const { onChange } = this.props;

        event.target.value = event.target.value.sort((a, b) => a >= b);

        onChange(event);
    };

    render() {
        const { selected, size } = this.props;

        return (

            <TextField
                id={"statuts"}
                name={"statuts"}
                label={"Statut(s)"}
                fullWidth

                select
                SelectProps={{
                    multiple: true,
                    value: selected,
                    onChange: this.handleChange,
                    renderValue: (selected) => {
                        return (selected.map(x => names[x]).join(', '));
                    }
                }}
                size={size}
            >

                <MenuItem value="" disabled>Sélectionner un ou plusieurs statuts</MenuItem>

                {names.map((name, index) => (
                    <MenuItem key={index} value={index}>

                        <Checkbox checked={selected.indexOf(index) > -1} />
                        <ListItemText primary={name} />
                    </MenuItem>
                ))}

            </TextField>


        );
    }
}


MultipleStatutSelect.propTypes = {
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
    size: PropTypes.string
};

export default MultipleStatutSelect;